<template>
  <div class='SelectMerchant_Warp'>
    <div class="SelectMerchant">
      <div class="Close"><i class="el-icon-close" @click="close"></i></div>
      <div class="Title">选择商户</div>
      <div class="From YFrom">
        <el-form :inline="true" :model="formInline" :label-width="`${Scaling(120)}px`">
          <el-form-item label="所属商场：">
            <el-select v-model.trim="formInline.mallId">
              <el-option v-for="(item, index) in MallIdList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商铺铺号：" v-if="!this.shopType">
            <el-input v-model.trim="formInline.storeCode" placeholder="请输入商铺铺号"></el-input>
          </el-form-item>
          <el-form-item label="关联品牌：">
            <el-input v-model.trim="formInline.brandName" placeholder="请输入关联品牌"></el-input>
          </el-form-item>
          <el-form-item label="商户名称：">
            <el-input v-model.trim="formInline.shopName" placeholder="请输入商户名称"></el-input>
          </el-form-item>
          <el-form-item class="YForm_Btn">
            <el-button type="primary" @click="onSubmit" >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="Table YTableStyle">
        <el-table
          :data="tableData"
          v-loading="loading"
          border
          style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTiles"
            :key="index"
            align='center'
            :show-overflow-tooltip='true'
            :prop="item.prop"
            :label="item.label">
          </el-table-column>
          <el-table-column
            align='center'
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="select(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="Pagination">
        <el-pagination
          :current-page="CurrentPage"
          :page-size="PageSize"
          layout="total, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="Total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/apps/inspection'
export default {
  name: 'SelectMerchant',

  data () {
    return {
      Total: 0,
      PageSize: 4,
      CurrentPage: 1,
      loading: false,
      shopType: 0,
      tableTiles: [
        {
          prop: 'storeCodes',
          label: '商铺铺号'
        },
        {
          prop: 'brandName',
          label: '关联品牌'
        },
        {
          prop: 'shopName',
          label: '商户名称'
        }
      ],
      tableTiles2: [
        {
          prop: 'brandName',
          label: '关联品牌'
        },
        {
          prop: 'shopName',
          label: '商户名称'
        }
      ],
      tableData: [],
      MallIdList: [],
      formInline: {
        mallId: '',
        storeCode: '',
        brandName: '',
        shopName: ''
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.MallOption()
    },

    // 获取当前用户的所有商场的名字和id,用作选择项
    MallOption () {
      const params = {
        method: api.option
      }
      this.loading = true
      this.axios.post(params).then(res => {
        if (res.data.backend_org_brms_mallinfo_list_for_option_response.code !== '10000') return
        this.MallIdList = res.data.backend_org_brms_mallinfo_list_for_option_response.items
        this.formInline.mallId = this.MallIdList[0].id
        this.GetDataList()
      })
    },

    GetDataList () {
      const params = {
        method: api.getShopInfo,
        mallId: this.formInline.mallId,
        brandName: this.formInline.brandName,
        shopName: this.formInline.shopName,
        pageNum: this.CurrentPage,
        pageSize: this.PageSize,
        storeCode: this.formInline.storeCode
      }
      this.loading = true
      this.axios.post(params).then(res => {
        this.loading = false
        if (res.data.backend_org_brms_inside_mallShopInfo_page_list_response.code !== '10000') return
        this.tableData = res.data.backend_org_brms_inside_mallShopInfo_page_list_response.result.records
        this.Total = parseInt(res.data.backend_org_brms_inside_mallShopInfo_page_list_response.result.total)
      })
    },

    onSubmit () {
      this.GetDataList()
    },

    handleSizeChange (val) {
      this.PageSize = val
      this.CurrentPage = 1
      this.GetDataList()
    },

    handleCurrentChange (val) {
      this.CurrentPage = val
      this.GetDataList()
    },

    close () {
      this.$emit('close')
    },

    select (row) {
      this.$emit('select', row)
    },

    Scaling (val) {
      if (document.querySelector('html').offsetWidth <= 1280) {
        return 1280 / 1920 * val
      } else {
        return document.querySelector('html').offsetWidth / 1920 * val
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
  .el-form-item
    display inline-block !important
  .YForm_Btn
    float right
    vertical-align bottom
    margin-top 38px
  .SelectMerchant_Warp
    position fixed
    left 0
    top 0
    height 100%
    width 100%
    background rgba(0, 0 , 0, .3)
    z-index 1
    display flex
    justify-content center
    align-items center
    .SelectMerchant
      height 70%
      background #ffffff
      border-radius 10px
      padding 20px
      box-sizing border-box
      display flex
      flex-direction column
      .Close
        display flex
        justify-content flex-end
        i
          font-size 16px
          cursor pointer
          &:hover
            color rgb(77, 144, 254)
      .Title
        font-size 26px
        line-height 26px
        color #333333
        font-weight bold
        text-align center
      .From
        margin-top 40px
      .Table
        flex auto
        margin-top 20px
      .Pagination
        margin-top 20px
        text-align center

</style>
